import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useCancelReservationMutation } from "../../../../../store/services/ReservationService";
import { hideModal } from "../../../../../store/slices/modalSlice";
import { useTypedDispatch, useTypedSelector } from "../../../../../store/store";
import Alert from "../../../../shared/Alert";
import Button from "../../../../shared/Button";

import styles from "./index.module.scss";

function CancelBookingModal() {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();

  const { data: pnr } = useTypedSelector((state) => state.modal);

  const [cancelReservation] = useCancelReservationMutation();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleKeep = () => {
    dispatch(hideModal());
  };

  const handleConfirmCancel = async () => {
    if (!pnr) {
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      await cancelReservation({ pnr }).unwrap();
      dispatch(hideModal());
    } catch {
      setError(t("Failed to cancel booking. Please try again."));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.pnr}>
        {t("Booking ID")}: {pnr}
      </p>

      <p className={styles.message}>
        {t(
          "Are you sure you want to cancel this booking? This action cannot be undone.",
        )}
      </p>

      {error && (
        <div className={styles.error}>
          <Alert message={error} />
        </div>
      )}

      <div className={styles.actions}>
        <Button
          label={t("No, keep it")}
          variant="secondary"
          size="md"
          onClick={handleKeep}
          disabled={isLoading}
        />

        <Button
          label={isLoading ? t("Cancelling...") : t("Yes, cancel booking")}
          variant="primary"
          size="md"
          onClick={handleConfirmCancel}
          loading={isLoading}
          className={styles.confirmButton}
        />
      </div>
    </div>
  );
}

export default CancelBookingModal;
